<app-header></app-header>
<app-sidebar></app-sidebar>
<app-spinner></app-spinner>
<router-outlet></router-outlet>
<p-confirmDialog [style]="{'max-width': '500px', 'top': '-15%'}"
  acceptLabel="Confirm" rejectLabel="Cancel"></p-confirmDialog>
<p-toast [baseZIndex]="999999"></p-toast>